import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';
import { formatSwissNumber } from 'utils/formatNumber';
import DoseField from 'features/Croptimizer/components/Fields/DoseField';
import FrequencyField from 'features/Croptimizer/components/Fields/FrequencyField';

interface SoilPhSectionProps {
  isGreaterTarget: boolean;
  getMthaText: string;
  getMtha: string;
  isExpertMode: boolean;
}

export const SoilPhSection = ({
  isGreaterTarget,
  getMthaText,
  getMtha,
  isExpertMode,
}: SoilPhSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="break-inside-avoid mt-8"> 
      <div className="text-black font-bold text-xl md:text-lg mb-6 md:mt-6">
        {isGreaterTarget ? t('improvementSoilPh') : t('maintainingSoilPh')}
      </div>
      <div className="flex mx-[-0.5rem]">
        {isExpertMode && 
          <>
            <div className="w-1/3 px-2">
              <DoseField isGerman />
            </div>
            <div className="w-1/3 px-2">
              <FrequencyField isGerman />
            </div>
          </>
        }
        <div className='w-1/3 px-2'>
          <MaskInput
            titleClassName="top-[-9px] left-[8px] bg-disable-gradient truncate max-w-[85%]"
            title={getMthaText}
            className="w-full"
            disabled
            value={formatSwissNumber(Number(getMtha))}
          />
        </div>
      </div>
    </div>
  );
};
